import React from 'react';
import classNames from 'classnames';

import { IconDelete } from '@/components/icons/IconDelete';
import { IconEditV2 } from '@/components/icons/IconEditV2';

import styles from './ActionIcon.module.scss';

type Props = {
  type: 'Add note' | 'Cancel' | 'Delete' | 'Edit' | 'Save';
  onClick(): void;
};

export const ActionIcon = ({ type, onClick }: Props) => {
  const iconProps = {
    classes: { container: styles.icon_container },
    color: '#2774AE',
  };

  const getContent = (): JSX.Element | null => {
    switch (type) {
      case 'Add note':
      case 'Edit':
        return (
          <>
            <IconEditV2 {...iconProps} />
            <span className={styles.icon_label}>{type}</span>
          </>
        );

      case 'Delete':
        return (
          <>
            <IconDelete {...iconProps} />
            <span className={styles.icon_label}>{type}</span>
          </>
        );

      case 'Save':
        return <span className={classNames(styles.icon_label, styles.text_action)}>{type}</span>;

      case 'Cancel':
        return (
          <span className={classNames(styles.icon_label, styles.text_action, styles.cancel_action)}>
            {type}
          </span>
        );

      default:
        return null;
    }
  };

  return (
    <div className={styles.action} onClick={onClick}>
      {getContent()}
    </div>
  );
};
